'use strict';

module.exports = {
  DEFAULT_API_VERSION: '20160516',
  DEFAULT_MAX_STEPS: 5,
  DEFAULT_WIT_URL: 'https://api.wit.ai'
};


//////////////////
// WEBPACK FOOTER
// ./~/node-wit/lib/config.js
// module id = 192
// module chunks = 0